module.exports = function(app) {
	app.run(['Service','sessionData', function(Service, sessionData) {
		return new Service({

			name: 'validateSSN',
			group: 'eprsvc',
			url: '/eprsvc/x-services/secure/employees/v1/ssn/:subscriberSSN',
			cache: false,

			fetch: function() {
                return this.get();
			},
			getData: function (param) {
                this.url = '/eprsvc/x-services/secure/employees/v1/fraudCheck';
                if(sessionData && sessionData.clientNumber && sessionData.clientNumber !== undefined){
                    this.headers['ClientNumber']  = sessionData.clientNumber;
                }
				return this.post({ payload: param });//Changes for PM78639
            }
		});
	}]);
};
